module.exports = "/_next/static/images/1ed0d08fb4583619a0e357d1edda09c2-apple-screen.png.webp";